import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import UserProvider from "./Components/Usercontext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserProvider>
    <App />
  </UserProvider>
);
